import { render, staticRenderFns } from "./EditErrorOrder.vue?vue&type=template&id=0a57f831&scoped=true&lang=pug&"
import script from "./EditErrorOrder.vue?vue&type=script&lang=js&"
export * from "./EditErrorOrder.vue?vue&type=script&lang=js&"
import style0 from "./EditErrorOrder.vue?vue&type=style&index=0&id=0a57f831&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a57f831",
  null
  
)

/* custom blocks */
import block0 from "./EditErrorOrder.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDivider,VSpacer})
